/**
 * Mappers for cost centers list operations
 */

import type {
  CostCenterListItem,
  CostCentersListResult,
  LC_CostCenterListItem,
  LC_GetCostCentersListOut,
} from '../types';


export function mapCostCenterListItemFromTransport(
  transport: LC_CostCenterListItem,
): CostCenterListItem {
  return {
    id: transport.costCenterId,
    code: transport.costCenterCode,
    name: transport.costCenterName,
    description: transport.description,
    createdAt: transport.createdAt,
    modifiedAt: transport.modifiedAt || undefined,
    modifiedBy: transport.modifiedBy || undefined,
    isEnabled: ['enabled', 'habilitado'].includes(transport.status?.toLowerCase() ?? ''),
  };
}

export function mapCostCentersListFromTransport(
  transport: LC_GetCostCentersListOut,
): CostCentersListResult {
  return {
    items: transport.data ? transport.data.map(mapCostCenterListItemFromTransport) : [],
    page: transport.pagination.currentPage,
    pageSize: transport.pagination.pageSize,
    totalRecords: transport.pagination.totalRecords,
    totalPages: transport.pagination.totalPages,
  };
}
